export const environmentTypes = {
    premise: "premise",
    dev: "dev",
    prod: "prod",
    uat: "uat",
    translation: "translation",
    demo: "demo",
}
